import { useContext } from 'react';
import { MultiStepFormContext } from '@kanda-libs/ks-component-ts';
import { useClasses } from '@kanda-libs/ks-design-library';
import { STEP_CLASS_NAMES } from '../MultiStepFormStepSidebar/constants';

export default function useStepItem(index) {
  const { currentStepIndex } = useContext(MultiStepFormContext);

  const active = index === currentStepIndex;

  const classNames = useClasses(STEP_CLASS_NAMES, {
    variants: {
      active,
    },
  });

  return {
    number: index + 1,
    classNames,
  };
}
